// Import external
import { Component, Input, OnInit } from '@angular/core';

// Import internal
import { Inventory } from '@data/models/inventory.model';
import { InventoryUtils } from '@data/services/inventory.utils';

@Component({
    selector: 'syn-inventory-avatar',
    templateUrl: 'inventory-avatar.component.html'
})
export class InventoryAvatarComponent implements OnInit {
    @Input() inventory: Inventory;
    @Input() titleInfos = '';
    @Input() showLegend = false;
    @Input() showId = false;
    @Input() caption = '';
    @Input() size = 32;
    @Input() legend;
    @Input() maxWidth;
    @Input() wrap = false;
    @Input() clickable = true;
    @Input() tooltip = false;
    @Input() backgroundColor: string;
    @Input() iconColor: string;

    public synIco = '';
    public title = '';
    public text = '';
    public link = '/inventory/';

    constructor(private utils: InventoryUtils) {
    }

    ngOnInit() {
        this.synIco = this.utils.assetIco(this.inventory);
        const legend = this.legend ? ' (' + this.legend + ')' : '';
        this.title = this.utils.assetType(this.inventory) + legend;
        this.text = !this.showLegend ? this.showId ? this.inventory.id : '' : this.inventory.name;
        this.link += this.inventory.id;
    }

}
